import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IConversationIDsAPIResponseNormalized } from '../../shared/models/conversation-ids.model';
import { TDataQueryName } from '../../core/configurations/router';
import { EScreenSizeBreakPoint, EViewMode } from '../../core/configurations/application';

export interface IDataQueryParam {
  queryName: TDataQueryName;
  value: string;
}

export const APPLICATION_ACTIONS = createActionGroup({
  source: 'Application',
  events: {
    'show loader': emptyProps(),
    'hide loader': emptyProps(),
    setDataQueryParam: props<IDataQueryParam>(),
    setScreenSizeBreakpoint: props<{ breakpoint: EScreenSizeBreakPoint }>(),
    setViewMode: props<{ viewMode: EViewMode | null }>(),
  },
});

export const CONVERSATION_IDS_API_ACTIONS = createActionGroup({
  source: 'Conversation IDs API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: IConversationIDsAPIResponseNormalized }>(),
  },
});
